import { AlkLogger, isNil } from '@alk/core';
import { ExtraDigitSize } from '@fnx/fx-pad/dist/types/interfaces/prices.interface';
import { IPoint as IGatewayPoint, IPrice as IGatewayPrice } from 'sfx-web-contract';
import { IPoint, IPrice } from '@fnx/fx-pad';

export function fromGatewayPrice(gatewayPrice: IGatewayPrice): IPrice {

    if (!Boolean(gatewayPrice)) {
        return null;
    }

    const validationResult = validateExtraDigits(gatewayPrice);

    if (Boolean(validationResult)){
        throw validationResult;
    }

    return {
        Value: gatewayPrice.Value,
        ExtraDigits: gatewayPrice.ExtraDigits as ExtraDigitSize,
        FractionSize: gatewayPrice.FractionSize,
    };
}

export function fromGatewayPoint(gatewayPoint: IGatewayPoint): IPoint {

    if (!Boolean(gatewayPoint)) {
        return null;
    }

    const validationResult = validateExtraDigits(gatewayPoint);

    if (Boolean(validationResult)){
        throw validationResult;
    }

    return {
        Value: gatewayPoint.Value,
        ExtraDigits: gatewayPoint.ExtraDigits as ExtraDigitSize,
    };
}

export function validateExtraDigits(gatewayPrice: IGatewayPrice | IGatewayPoint): null | Error {
    const extraDigits = gatewayPrice.ExtraDigits as ExtraDigitSize;

    // In runtime js has no idea about literal number types, so need to check manually
    if (isNil(extraDigits) || extraDigits < 0 || extraDigits > 3) {
        const errMsg = [
            `[QUOTE_STREAM_ADAPTER] Decoding error ExtraDigits ${ gatewayPrice.ExtraDigits }`,
            `cannot be converted to type ExtraDigitSize`,
        ].join(' ');
        AlkLogger.error(errMsg);
        return new Error(errMsg);
    }
    return null;
}
